var shadows = {
    "shadow-high": "0px 12px 20px rgba(106, 115, 129, 0.22);",
    "shadow-med": "0px 6px 12px rgba(106, 115, 129, 0.16), 0px 3px 8px rgba(87, 102, 117, 0.06);",
    "shadow-low": "0px 2px 8px rgba(106, 115, 129, 0.12);",
    "shadow-btn": "0px 1px 0px 0px rgba(0, 0, 0, 0.25);",
};

export { shadows as default };
//# sourceMappingURL=shadows.js.map
